import { render, staticRenderFns } from "./TimeFrame.vue?vue&type=template&id=4c4e355e&scoped=true&"
import script from "./TimeFrame.vue?vue&type=script&lang=js&"
export * from "./TimeFrame.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrame.vue?vue&type=style&index=0&id=4c4e355e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e355e",
  null
  
)

export default component.exports